import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import ChooseFromDestinationsPng2x from './assets/ChooseFromDestinations@2x.png'
import ChooseFromDestinationsWebp from './assets/ChooseFromDestinations.webp'
import ChooseFromDestinationsWebp2x from './assets/ChooseFromDestinations@2x.webp'

const copy = {
  heading: `Choose from hundreds of destinations`,
  description: `Segment partners with the top tools in mobile, so you can try best-in-class platforms for mobile marketing
automation, analytics, and more.`,
}

const link = {
  text: `View Segment Destinations`,
  url: `/catalog/`,
}

const ChooseFromDestinations = () => {
  const pageConfig = usePageConfig()

  return (
    <SectionBase variant="2Col" reverse={true}>
      <SectionCopy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h3">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
          <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
        </CopyTextBase>
      </SectionCopy>
      <Section.Contents>
        <picture>
          <source type="image/webp" srcSet={`${ChooseFromDestinationsWebp}, ${ChooseFromDestinationsWebp2x} 2x`} />
          <StyledImage
            src={ChooseFromDestinationsPng2x}
            alt="Illustration: Activate anywhere"
            width="958"
            height="773"
            loading="lazy"
          />
        </picture>
      </Section.Contents>
    </SectionBase>
  )
}

const StyledImage = styled(Image)`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

const SectionCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
  }
`

export default ChooseFromDestinations
